import { render } from "./DictionaryTree.vue?vue&type=template&id=28c70f16&scoped=true"
import script from "./DictionaryTree.vue?vue&type=script&lang=js"
export * from "./DictionaryTree.vue?vue&type=script&lang=js"

import "./DictionaryTree.vue?vue&type=style&index=0&id=28c70f16&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c70f16"],['__file',"src/views/h5/common/basedata/dictionary/DictionaryTree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28c70f16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28c70f16', __exports__)) {
    api.reload('28c70f16', __exports__)
  }
  
  module.hot.accept("./DictionaryTree.vue?vue&type=template&id=28c70f16&scoped=true", () => {
    api.rerender('28c70f16', render)
  })

}


export default __exports__